interface BuildStringOptions {
  separator: string;
}

const defaultBuildStringOptions: BuildStringOptions = {
  separator: " ",
};

export function buildString(
  parts: (string | number | null | undefined)[] = [],
  options = defaultBuildStringOptions,
  transform: (value: string) => string = (value) => value
): string {
  return parts
    .filter(Boolean)
    .map((i) => (typeof i === "string" ? transform(i) : i))
    .join(options.separator);
}

export function getIntFromString(value: string | number) {
  return typeof value === "string" ? parseInt(value) : value;
}

export function getTextByCount(count: number, singularText: string, pluralText: string) {
  return count === 1 ? singularText : pluralText;
}

export function getStringWithParams<T extends Record<string, unknown>>({ base, params }: { base: string; params?: T }) {
  if (!params) return base;

  const queryString = Object.entries(params).reduce((acc, [key, value]) => {
    if (value === undefined) {
      return acc;
    }
    const param = `${key}=${value}`;
    return acc ? buildString([acc, param], { separator: "&" }) : param;
  }, "");

  return queryString ? buildString([base, queryString], { separator: "?" }) : base;
}
